module.exports = __webpack_public_path__ + "static/media/giovanni-3.c8129682.wav";